import React from 'react';
import classNames from 'classnames';
import cls from './ProjectTeamManagersRow.module.css';
import { useProjectTeamManagersRow } from './useProjectTeamManagersRow';
import { CardList } from '../../UI/CardList/CardList';
import { PeopleCard } from '../../UI/PeopleCard/PeopleCard';
import { CardTitle } from '../../UI/CardTitle/CardTitle';
import { CardType, InviteCard } from '../../UI/InviteCard/InviteCard';
import { OpenedInviteCard } from '../../useProjectTeamInvite';
import { EmployersForSelect } from '../../../../../TemporaryConmonents/AddProject/SecondStep/useSecondStep';
import { Roles } from '../../../../../TemporaryConmonents/AddProject/types/types';
import { useTranslation } from 'react-i18next';

interface ProjectTeamManagersRowProps {
    classes?: string;
    openedInviteCard: OpenedInviteCard;
    onOpenedInviteCardChange: (value: OpenedInviteCard) => void;
    employersList: EmployersForSelect[];
    onEmployersListSet: (value: string) => void;
    closingCard: string;
    onSetClosingCard: (value: string) => void;
}

export const ProjectTeamManagersRow = ({
    classes,
    openedInviteCard,
    onOpenedInviteCardChange,
    onEmployersListSet,
    employersList,
    onSetClosingCard,
    closingCard,
}: ProjectTeamManagersRowProps) => {
    const { t } = useTranslation();
    const { managers } = useProjectTeamManagersRow();
    return (
        <div className={classNames(cls.ProjectTeamManagersRow, [classes])}>
            <CardTitle
                title={t('ProjectTeam.ProjectTeamInvite.ProjectTeamManagersRow.CardTitle')}
                role={Roles.MANAGER}
            />
            <CardList>
                <InviteCard
                    closingCard={closingCard}
                    onSetClosingCard={onSetClosingCard}
                    onEmployersListSet={onEmployersListSet}
                    employersList={employersList}
                    type={CardType.MANAGER}
                    openedInviteCard={openedInviteCard}
                    onOpenedInviteCardChange={onOpenedInviteCardChange}
                />
                {managers.ids.map((id) => (
                    <PeopleCard employerId={id} type={Roles.MANAGER} />
                ))}
            </CardList>
        </div>
    );
};
